import {settingsService} from '../services/service-factory';

export default {
  data: function() {
    return {
      settingsService: undefined
    };
  },
  created: function() {
    this.settingsService = settingsService;
  }
};